import React, { useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import { SpendingAggregationList } from "./List";
import { SpendingAggregationDrawer } from "./Drawer";

export default function CanonicalAggregationsPage() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedAggregation, setSelectedAggregation] = useState(null);

  const handleRowClick = ({ row }) => {
    setSelectedAggregation(row);
    setIsDrawerOpen(true);
  };

  const handleNewClick = () => {
    setSelectedAggregation({});
    setIsDrawerOpen(true);
  };

  const handleClose = () => {
    setIsDrawerOpen(false);
    setSelectedAggregation(null);
  };

  return (
    <Box paddingX="32px" display="flex" width="100%" justifyContent="center">
      <Box width="100%" maxWidth="1536px">
        <Typography variant="h4" component="h1" gutterBottom>
          Canonical Aggregations (Watchlists)
        </Typography>
        <Divider />

        <SpendingAggregationList
          onRowClick={handleRowClick}
          onNewClick={handleNewClick}
        />
      </Box>

      {selectedAggregation && (
        <SpendingAggregationDrawer
          aggregation={selectedAggregation}
          isOpen={isDrawerOpen}
          onClose={handleClose}
        />
      )}
    </Box>
  );
}
